<template>
  <div class="app-order-options">
    <slot name="txtBefore"></slot>
    <b-form
      class="checkout-top-up-form"
      :id="'form' + _uid"
      :novalidate="true">
      <slot name="txtBeforeMnp"><h2>Rufnummermitnahme</h2></slot>
      <EnterOptionsMnpData
        :mnp-providers="mnpProviders"
        :mnp-data.sync="mnpData"
        :mnp-invalid.sync="mnpInvalid"
      >
        <template v-for="slot in possibleChildSlotsFor('Mnp')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </EnterOptionsMnpData>
      <slot name="txtBeforeTopUp"><h2>Guthaben aufladen</h2></slot>
      <checkout-auto-single-top-up-wrapper
        :selected-top-up-types.sync="selectedTopUpTypes"
        :autoTopUp.sync="autoTopUp"
        :singleTopUp.sync="singleTopUp"
        :topUpAmounts="topUpAmounts"
      >
        <template v-for="slot in possibleChildSlotsFor('AutoSingle')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </checkout-auto-single-top-up-wrapper>
    </b-form>
    <div class="order-step">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="save" class="btn-next" type="button" variant="primary" :disabled="invalidSelection">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import preFilledInput from '@/mixins/preFilledInput'
import CheckoutAutoSingleTopUpWrapper
  from '@/components/process/FYVE/Order/TopUp/EnterTopUp.vue'
import transaction from '@/mixins/transaction'
import EnterOptionsMnpData from '@/components/process/FYVE/Order/Options/EnterOptionsMnpData.vue'
import gtmEvent from '@/mixins/gtmEvent'

export const stepName = 'options'
export default {
  name: 'EnterOptions',
  mixins: [
    transaction('orderOptions'),
    preFilledObjectInput('autoTopUp', 'storedAutoTopUp'),
    preFilledInput('singleTopUp', 'storedSingleTopUp'),
    preFilledInput('selectedTopUpTypes', 'defaultSelectedTopUpTypes'),
    preFilledObjectInput('mnpData', 'storedMnpData'),
    preFilledInput('friendMsisdn', 'storedFriendMsisdn'),
    slotProxy(),
    gtmEvent
  ],
  components: {
    EnterOptionsMnpData,
    CheckoutAutoSingleTopUpWrapper,
    BButton
  },
  computed: {
    ...mapGetters('orderProduct', [
      'getStep'
    ]),
    ...mapGetters('orderProduct/topUp', {
      storedAutoTopUp: 'topUp',
      storedSingleTopUp: 'singleTopUpAmount',
      storedSelectedTopUpTypes: 'selectedTopUpTypes'
    }),
    ...mapGetters('orderProduct/mnp', {
      storedMnpData: 'mnpData'
    }),
    ...mapGetters('orderProduct/referFriend', {
      storedFriendState: 'friendState'
    }),
    ...mapGetters('friendNotification', {
      storedFriendMsisdn: 'existingCustomerMsisdn',
      storedDisabledReferFriend: 'disableReferFriend'
    }),
    ...mapGetters('orderProduct/gtmEventData', [
      'getTariffName',
      'getTariffProductNumber',
      'getTariffPrice'
    ]),
    defaultSelectedTopUpTypes: function () {
      if (this.storedSelectedTopUpTypes.length === 0) {
        return [
          'without'
        ]
      }
      return this.storedSelectedTopUpTypes
    },
    invalidSelection: function () {
      const invalid = this.loading || (this.mnpInvalid && this.mnpData.active) || this.storedDisabledReferFriend

      return invalid === false ? false : this.friendMsisdn !== ''
    }
  },
  data () {
    return {
      loading: false,
      mnpInvalid: false
    }
  },
  methods: {
    ...mapActions('orderProduct/referFriend', [
      'checkReferFriend'
    ]),
    ...mapMutations('orderProduct/topUp', {
      storeSelection: 'storeSelection',
      storeAutoTopUpData: 'storeAutoTopUpData',
      storeSingleTopUpData: 'storeSingleTopUpData'
    }),
    ...mapMutations('orderProduct/mnp', {
      storeMnpData: 'storeMnpData'
    }),
    ...mapMutations('orderProduct', {
      changeStep: 'changeStep',
      commitOptions: 'commitOptions'
    }),
    back () {
      this.goToStep(this.previousStep)
    },
    async save () {
      if (this.mnpInvalid && this.mnpData.active) {
        return
      }
      this.loading = true
      await this.checkReferFriend({ friendMsisdn: this.friendMsisdn })
      this.storeSelection(this.selectedTopUpTypes)
      this.storeAutoTopUpData(this.autoTopUp)
      this.storeSingleTopUpData(this.singleTopUp)
      this.storeMnpData(this.mnpData)
      this.commitOptions({ options: true })
      if (this.storedFriendState) {
        this.changeStep({ step: this.nextStep })
      }
      this.pushEventCheckout('eec.checkoutStep', this.getStep, this.getTariffName, this.getTariffProductNumber, this.getTariffPrice, 'fyve')
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'personalData'
    },
    topUpAmounts: {
      type: Object,
      default: null
    },
    mnpProviders: {
      type: Array,
      default: () => []
    }
  }
}
</script>
